export default url => url.indexOf('/') === 0 || url.indexOf(`${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_HOST_NAME}`) === 0



// WEBPACK FOOTER //
// ./src/utils/isInternal.js